module.exports = __webpack_public_path__ + "img/easyBuy.b33735f.svg";